import { ModalContent, ModalHeader, ModalCloseButton, ModalBody, Box, Button, Text } from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormikInput } from 'components/Formik';
import { useConnectSandataIndiana } from 'hooks/integrations/sandataIndiana/useConnectSandataIndiana';

import { connectFormValidationSchema, initialConnectFormData } from './schema';

interface IEvvConnectFormProps {
  onClose: () => void;
}

const ConnectForm: React.FC<IEvvConnectFormProps> = ({ onClose }) => {
  const { t } = useTranslation(['common', 'integrations']);

  const { mutateAsync, isLoading } = useConnectSandataIndiana();

  const handleFormSubmit = (values: typeof initialConnectFormData) => {
    mutateAsync(values).then(() => {
      onClose();
    });
  };

  return (
    <ModalContent>
      <ModalHeader>{t('integrations:sandataIndiana.connectToSandataIndiana')}</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Formik
          enableReinitialize
          initialValues={initialConnectFormData}
          validationSchema={connectFormValidationSchema}
          onSubmit={handleFormSubmit}
        >
          {() => (
            <Form noValidate>
              <FormikInput
                type="text"
                name="entity_guid"
                label={t('integrations:sandataIndiana.entityID')}
                formControlProps={{ isRequired: true }}
              />
              <FormikInput
                type="text"
                name="provider_qualifier"
                label={
                  <>
                    {t('integrations:sandataIndiana.providerQualifier')}{' '}
                    <Text as="span" textTransform="initial">
                      ({t('integrations:sandataIndiana.providerQualifierHint')})
                    </Text>
                  </>
                }
                formControlProps={{ isRequired: true }}
              />
              <FormikInput
                type="text"
                name="account"
                label={t('common:accountNumber')}
                formControlProps={{ isRequired: true }}
              />
              <FormikInput
                type="text"
                name="username"
                label={t('common:username')}
                formControlProps={{ isRequired: true }}
              />
              <FormikInput
                type="password"
                name="password"
                label={t('common:password')}
                formControlProps={{ isRequired: true }}
              />
              <FormikInput
                type="text"
                name="payer_id"
                label={t('integrations:sandataIndiana.payerId')}
                formControlProps={{ isRequired: true }}
              />
              <FormikInput
                type="text"
                name="payer_program"
                label={t('integrations:sandataIndiana.payerProgram')}
                formControlProps={{ isRequired: true }}
              />
              <Box textAlign="right">
                <Button bg="gray.600" _hover={{ bg: 'gray.700' }} _active={{ bg: 'gray.700' }} onClick={onClose}>
                  {t('common:close')}
                </Button>
                <Button type="submit" colorScheme="secondary" isLoading={isLoading} ml="5">
                  {t('integrations:connect')}
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </ModalContent>
  );
};

export default ConnectForm;
